<div class="grid place-items-center min-h-[60vh] px-4">
  <div class="flex flex-col items-center text-center gap-4">
    <mat-icon class="!w-16 !h-16 !text-6xl opacity-40" style="color: var(--mat-sys-on-surface-variant)">find_in_page</mat-icon>
    <h1 class="page-title !mb-0">{{ 'common.pageNotFound' | translate }}</h1>
    <a matButton="filled" routerLink="/events">
      <mat-icon>arrow_back</mat-icon>
      {{ 'common.backToEvents' | translate }}
    </a>
  </div>
</div>
